import { useGetAvatarSignedUrl, useUploadAvatar } from 'src/workspace/api'
import { isNilOrEmpty } from 'shared/utils'

interface UseAvatarUpload {
  mutateAsync: (file: File) => Promise<void>
  isLoading: boolean
  isSuccess: boolean
  isError: boolean
}

export const useAvatarUpload = (
  params: { clientId: number; userId?: never } | { clientId?: never; userId: number | undefined }
): UseAvatarUpload => {
  const { clientId, userId } = params
  const {
    mutateAsync: createSignedUrl,
    isPending: isLoadingSignedUrl,
    isError: isErrorSignedUrl
  } = useGetAvatarSignedUrl({ clientId: clientId ?? null, userId })
  const {
    mutateAsync: uploadAvatar,
    isPending: isUploading,
    isSuccess: isSuccessUploadingFile,
    isError: isErrorUploadingFile
  } = useUploadAvatar({ clientId: clientId ?? null, userId })

  const handleUploadFile = async (file: File): Promise<void> => {
    const data = await createSignedUrl()
    if (data?.signedUrl != null && data?.signedUrl !== '' && !isNilOrEmpty(file)) {
      await uploadAvatar({ file, signedURL: data.signedUrl })
    }
  }

  return {
    mutateAsync: handleUploadFile,
    isLoading: isLoadingSignedUrl || isUploading,
    isSuccess: isSuccessUploadingFile,
    isError: isErrorSignedUrl || isErrorUploadingFile
  }
}
